// 2020-06-27export { TropaCategoriaGanadoListComponent } from './tropa-categoria-ganado-list.component';